// src/components/Layout/Layout/Layout.component.jsx
import React, { useEffect, useState } from 'react';
import SideBar from '../SideBar/SideBar.component';
import NavBar from '../NavBar/NavBar.component';
import Content from '../PageContent/PageContent.component';

import SupportChatButton from '../../Universals/Support/supportChatButton.component.jsx';
import SupportAnnouncement from '../../Universals/Support/supportAnnouncement.component.jsx';

import { useDataLayer } from '../../../Contexts/DataLayer.context';
import { getPositions, startValues, LoadStatuses } from '../../../utils/loadFunctions.ts';
import { getCountry } from '../../../utils/loadFunctions.ts';
import { getSchools } from '../../../utils/loadFunctions.ts';
import { getAgents } from '../../../utils/loadFunctions.ts';
import { getEvents } from '../../../utils/loadFunctions.ts';
import { getUserFromToken } from '../../../utils/functions.ts';

import './Layout.style.scss';

const Layout = () => {
    const {
        positionArray, updatePositionArray,
        countryArray, updateCountryArray,
        schoolArray, updateSchoolArray,
        agentArray, updateAgentArray,
        eventArray, updateEventArray,
        arrayOfShared,
        updateArrayOfShared,
        updateActualShared,
    } = useDataLayer();

    const [userData, setUserData] = useState(null);
    const [, setStatusLoadVersion] = useState(0);

    useEffect(() => {
        const loadData = async () => {
            const user = await getUserFromToken();
            if (!user) return;

            setUserData(user);

            if (!Array.isArray(arrayOfShared) || arrayOfShared.length === 0) {
                const tempShareArray = (user.newShareOption || "").split(",").filter(Boolean);
                updateArrayOfShared(tempShareArray);

                const tempSharedArray = (user.newShare || "").split(",").filter(Boolean);
                updateActualShared(tempSharedArray);
            }

            try {
                await LoadStatuses();
                setStatusLoadVersion((version) => version + 1);
            } catch (error) {
                console.error("Error fetching statuses", error);
            }

            if (positionArray.length === 0) {
                try {
                    const positionData = await getPositions();
                    updatePositionArray(positionData);
                } catch (error) { }
            }

            if (countryArray.length === 0) {
                try {
                    const countryData = await getCountry();
                    updateCountryArray(countryData);
                } catch (error) {
                    console.error("Error fetching country", error);
                }
            }

            if (schoolArray.length === 0) {
                try {
                    const schoolData = await getSchools();
                    updateSchoolArray(schoolData);
                } catch (error) {
                    console.error("Error fetching School", error);
                }
            }

            if (agentArray.length === 0) {
                try {
                    const agentData = await getAgents();
                    updateAgentArray(agentData);
                } catch (error) {
                    console.error("Error fetching Agents", error);
                }
            }

            if (eventArray.length === 0) {
                try {
                    const eventData = await getEvents();
                    updateEventArray(eventData);
                } catch (error) {
                    console.error("Error fetching Events", error);
                }
            }

            const checkTokenS1 = localStorage.getItem("formValues");
            if (!checkTokenS1) {
                localStorage.setItem("formValues", JSON.stringify(startValues));
            }

            const checkTokenS2 = localStorage.getItem("s1output");
            if (!checkTokenS2) {
                localStorage.setItem("s1output", JSON.stringify({}));
            }
        };

        loadData();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="layout">
            <SideBar isShrunk={true} sideBarMax="200px" />
            <div className="main">
                <NavBar />
                <Content />
                <SupportChatButton />
                <SupportAnnouncement show={!!userData} />
            </div>
        </div>
    );
};

export default Layout;
